const AnimatedLogo = () => {
  const asterisk = document.querySelector('#asterisk');

  // if asterisk is not found, do nothing
  if (asterisk === null) {
    return () => {};
  }

  // every year, we turn quicker
  const companyAgeInYears = new Date().getFullYear() - 2009;
  const maxAngle = companyAgeInYears * 360;

  // micro-optimization
  let ratio;
  let angle;

  // debouncing for extra smoothness
  let timeout;

  const scrollListener = () => {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    timeout = window.requestAnimationFrame(() => {
      ratio =
        window.scrollY / (document.body.scrollHeight - window.innerHeight);
      angle = (ratio * maxAngle) % 360;
      // (transform: rotateZ) == (transform: rotate) + (will-change: transform)
      asterisk.style.transform = `rotateZ(${angle}deg)`;
    });
  };

  document.addEventListener('scroll', scrollListener);

  const destroy = () => {
    document.removeEventListener('scroll', scrollListener);
  };

  return destroy;
};

export default AnimatedLogo;



// WEBPACK FOOTER //
// ./src/scripts/modules/AnimatedLogo/index.js